import { Pipe, PipeTransform } from '@angular/core';

/**
 * Rounds to the nearest integer: values below .5 round down, .5 and above round up.
 */
@Pipe({
  name: 'roundNumber',
})
export class RoundNumberPipe implements PipeTransform {
  transform(value: unknown): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    const n = typeof value === 'number' ? value : Number(value);
    if (isNaN(n)) {
      return 0;
    }
    return Math.round(n);
  }
}